import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getIotDeviceData, singleUpdate,singleRestart } from "../../apis/Iot";
import { toast } from "react-toastify";
const IoTDeviceTable = () => {
  const auth = useSelector((state) => state.auth);
  const [filter, setFilter] = useState("All");
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [showUpdate, setShowUpdate] = useState(false);
  const [restartDevice, setRestartDevice] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);

  const { data, error, loading } = useQuery({
    queryKey: ["dashboard-iot-data"],
    queryFn: () => getIotDeviceData(auth?.token),
    enabled: !!auth?.token,
  });
if(error){
  toast.error("an error occurred  ")
}
if(loading){
  toast.loading("Loading IOT device  ")

}

  const mockData = data?.data?.data?.data || [];

  const filteredData = mockData.filter((device) => {
    if (filter === "All") return true;
    return device.status === filter;
  });

  const handleMenuToggle = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  // Open/close overlay
  const handleOpenUpdate = (device) => {
    setSelectedDevice(device);
    setShowUpdate(true);
  };
  const closeUpdate = () => {
    setShowUpdate(false);
    setSelectedDevice(null);
  };

  const handleOpenRestart = (device) => {
    setSelectedDevice(device);
    setRestartDevice(true);
  };
  const closeRestart = () => {
    setRestartDevice(false);
    setSelectedDevice(null);
  };

  const handleSingleUpdates= async( )=>{
    const response = await singleUpdate(auth?.token, selectedDevice.deviceId,selectedDevice.firmwareVersion)
        console.log('response', response);
        if(response.status=== 200)
        {
          toast.success("device uploaded successfully ")
        }
  }
  // console.log("tobackend",selectedDevice.deviceId)
 const handleSingleRestart = async () => {
  if (!selectedDevice?.deviceId) {
    console.error("No device selected for restart");
     toast.error("Failed to update device. Please try again.");
    return;
  }


  try {
    const device_id = selectedDevice.deviceId;

    const response = await singleRestart(auth?.token, device_id);
    if(response.status=== 200)
        {
          toast.success("device restart successfully ")
        }
  } catch (error) {
    console.error("Error restarting device:", error);
     toast.error("Failed to restart device. Please try again.");

  }
};

  


  return (
    <div className="p-6 ">
      <div className="bg-white shadow-md rounded-xl p-20 w-[1295px] text-[14px] border">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <h2 className="font-semibold text-lg text-gray-700">IOT Device</h2>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="border rounded px-3 py-2 text[14px] bg-white shadow-sm focus:outline-none "
          >
            <option value="All">Filter by</option>
            <option value="All">All</option>
            <option value="online">online</option>
            <option value="offline">offline</option>
          </select>
        </div>

        {/* Scrollable Table */}
        <div className="overflow-y-scroll text-[14px]">
          <table className="min-w-full text-left ml-10">
            <thead className="bg-green-700 h-[55px] text-white sticky top-2 w-full z-10 ml-5">
              <tr>
                <th className="px-3 py-3">ID</th>
                <th className="px-6 py-3">Firmware Version</th>
                <th className="px-6 py-3">Time</th>
                <th className="px-6 py-3">Date</th>
                <th className="py-3">Status</th>
                <th className="px-6 py-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((device, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-50 transition duration-200"
                >
                  <td className="px-6 py-4">{device.deviceId}</td>
                  <td className="px-6 py-4">{device.firmwareVersion}</td>
                  <td className="px-6 py-4">
                    {new Date(device.timestamp).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}
                  </td>
                  <td className="px-6 py-4">
                    {device.created_at
                      ? new Date(device.timestamp).toLocaleDateString("en-US")
                      : "--"}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center gap-2 px-3 py-3 text-[14px] border font-medium ${
                        device.status === "online"
                          ? " text-green-700 border-1"
                          : " text-red-700"
                      }`}
                    >
                      <span
                        className={`w-2 h-2 rounded-full ${
                          device.status === "online"
                            ? "bg-green-500"
                            : "bg-red-500"
                        }`}
                      ></span>
                      {device.status}
                    </span>
                  </td>

                  <td className="px-6 py-4 relative">
                    <button
                      onClick={() => handleMenuToggle(index)}
                      className="p-2 hover:bg-gray-100 rounded-full transition"
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.0013 2.66602C23.3653 2.66602 29.3346 8.63535 29.3346 15.9993C29.3346 23.3633 23.3653 29.3327 16.0013 29.3327C8.6373 29.3327 2.66797 23.3633 2.66797 15.9993C2.66797 8.63535 8.6373 2.66602 16.0013 2.66602ZM16.0013 5.33268C13.1723 5.33268 10.4592 6.45649 8.45883 8.45688C6.45844 10.4573 5.33464 13.1704 5.33464 15.9993C5.33464 18.8283 6.45844 21.5414 8.45883 23.5418C10.4592 25.5422 13.1723 26.666 16.0013 26.666C18.8303 26.666 21.5434 25.5422 23.5438 23.5418C25.5442 21.5414 26.668 18.8283 26.668 15.9993C26.668 13.1704 25.5442 10.4573 23.5438 8.45688C21.5434 6.45649 18.8303 5.33268 16.0013 5.33268ZM16.0013 19.9993C16.5317 19.9993 17.0404 20.2101 17.4155 20.5851C17.7906 20.9602 18.0013 21.4689 18.0013 21.9993C18.0013 22.5298 17.7906 23.0385 17.4155 23.4136C17.0404 23.7886 16.5317 23.9993 16.0013 23.9993C15.4709 23.9993 14.9622 23.7886 14.5871 23.4136C14.212 23.0385 14.0013 22.5298 14.0013 21.9993C14.0013 21.4689 14.212 20.9602 14.5871 20.5851C14.9622 20.2101 15.4709 19.9993 16.0013 19.9993ZM16.0013 13.9993C16.5317 13.9993 17.0404 14.2101 17.4155 14.5851C17.7906 14.9602 18.0013 15.4689 18.0013 15.9993C18.0013 16.5298 17.7906 17.0385 17.4155 17.4136C17.0404 17.7886 16.5317 17.9993 16.0013 17.9993C15.4709 17.9993 14.9622 17.7886 14.5871 17.4136C14.212 17.0385 14.0013 16.5298 14.0013 15.9993C14.0013 15.4689 14.212 14.9602 14.5871 14.5851C14.9622 14.2101 15.4709 13.9993 16.0013 13.9993ZM16.0013 7.99935C16.5317 7.99935 17.0404 8.21006 17.4155 8.58514C17.7906 8.96021 18.0013 9.46892 18.0013 9.99935C18.0013 10.5298 17.7906 11.0385 17.4155 11.4136C17.0404 11.7886 16.5317 11.9993 16.0013 11.9993C15.4709 11.9993 14.9622 11.7886 14.5871 11.4136C14.212 11.0385 14.0013 10.5298 14.0013 9.99935C14.0013 9.46892 14.212 8.96021 14.5871 8.58514C14.9622 8.21006 15.4709 7.99935 16.0013 7.99935Z"
                          fill="#667185"
                        />
                      </svg>
                    </button>

                    {openMenuIndex === index && (
                      <div className="absolute right-6 top-10 z-20 bg-white border rounded shadow-md text[14px]">
                        <button
                          onClick={() => handleOpenUpdate(device)}
                          className="w-full px-4 py-2 hover:bg-gray-100 text-center"
                        >
                          Update
                        </button>

                        <button
                          onClick={() => handleOpenRestart(device)}
                          className="w-full px-4 py-2 hover:bg-gray-100 text-center"
                        >
                          Restart
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}

              {filteredData.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center py-4 text-gray-500"
                  >
                    No devices found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Update overlay */}
        {showUpdate && selectedDevice && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
            onClick={closeUpdate}
          >
            <div className="relative" onClick={(e) => e.stopPropagation()}>
              <div className="bg-white p-10 w-[542px] h-[367px] text-center pt-[50px] rounded-xl">
                <div
                  className="float-right cursor-pointer"
                  onClick={closeUpdate}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6.75781 17.2438L12.0008 12.0008L17.2438 17.2438M17.2438 6.75781L11.9998 12.0008L6.75781 6.75781"
                      stroke="#D42620"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="font-semibold text-[24px] pt-20">
                  Update Device
                </div>

                <div className="mt-10 text-gray-500 text-[16px]">
                  You're about to update the configuration for{" "}
                  <span className="text-black">
                    {selectedDevice.deviceId}
                  </span>. This may include changes to network settings, firmware
                  version, or operational parameters.
                </div>

                <div className="flex justify-self-center pt-24 gap-10">
                  <button
                    onClick={closeUpdate}
                    className="p-5 w-[184.5px] bg-[#E5E5E5] rounded-xl"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={ handleSingleUpdates} 
                    className="p-5 text-white w-[184.5px] bg-gradient-to-r rounded-xl from-[#038B47] to-[#00AED9] hover:from-green-700 hover:to-green-600"
                  >
                    Proceed with Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Restart overlay */}
        {restartDevice && selectedDevice && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
            onClick={closeRestart}
          >
            <div className="relative" onClick={(e) => e.stopPropagation()}>
              <div className="bg-white p-10 w-[542px] h-[367px] text-center pt-[50px] rounded-xl">
                <div
                  className="float-right cursor-pointer"
                  onClick={closeRestart}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M6.75781 17.2438L12.0008 12.0008L17.2438 17.2438M17.2438 6.75781L11.9998 12.0008L6.75781 6.75781"
                      stroke="#D42620"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div className="font-semibold text-[24px] pt-20">
                  Restart Device
                </div>

                <div className="mt-10 text-gray-500 text-[16px]">
                  You're about to restart{" "}
                  <span className="text-black">
                    ({selectedDevice.deviceId})
                  </span>. Restarting will temporarily disconnect the device and
                  interrupt its current operations.
                </div>

                <div className="flex justify-self-center pt-24 gap-10">
                  <button
                    onClick={closeRestart}
                    className="p-5 w-[184.5px] bg-[#E5E5E5] rounded-xl"
                  >
                    Cancel
                  </button>
                  <button onClick={handleSingleRestart} className="p-5 text-white w-[184.5px] bg-gradient-to-r rounded-xl from-[#038B47] to-[#00AED9] hover:from-green-700 hover:to-green-600">
                    Restart Device
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default IoTDeviceTable;
